import { TravellerNameIdModel } from '../../../features/activities/api/useActivityStatusQuery';
import { useQuery } from '@tanstack/react-query';
import { ActivityEndpoints } from '../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../lib/axios';

export type ActivityHotelSearchInformationModel = {
  ActivityId: number;
  ApprovedBooker: TravellerNameIdModel;
  RequestedBy: TravellerNameIdModel;
  CheckInDate: string;
  CheckOutDate: string;
  CompanyId: number;
  CompanyName: string;
  CompanyRateCodes: string;
  FlsqNumber: number;
  GuestTravellers: number;
  PreferredCity: string;
  PreferredHotel: string;
  PreferredHotelId: number | undefined;
  Travellers: TravellerNameIdModel[];
  PreferredHotelChainCode?: string;
  PreferredHotelGdsId?: string;
  PreferredCityId?: number;
  Lat?: number;
  Lng?: number;
};

export function useActivityHotelSearchInformationQuery(activityId: number | undefined) {
  return useQuery<ActivityHotelSearchInformationModel>({
    queryKey: [ActivityEndpoints.hotelSearch.searchInformation(activityId!)],
    staleTime: 1,
    enabled: !!activityId,
    gcTime: 1,
    queryFn: async () => (await getAxios().get(ActivityEndpoints.hotelSearch.searchInformation(activityId!))).data
  });
}
